import React from 'react';
import { homeDeviceCategories } from './data';

type HomeDeviceCardModel = (typeof homeDeviceCategories)['cards'][number];

function DeviceCard({ card, photoWellBg }: { card: HomeDeviceCardModel; photoWellBg: string }) {
  return (
    <article
      className={`io-home-device-card io-home-device-card--${card.id}`}
      style={{ background: card.cardBg }}
    >
      <div className="io-home-device-card__inner">
        <h3 className="io-home-device-card__title">{card.title}</h3>
        <div className="io-home-device-card__photo" style={{ background: photoWellBg }}>
          <img src={card.image} alt={card.alt} className="io-home-device-card__img" loading="lazy" />
        </div>
      </div>
    </article>
  );
}

export const HomeDeviceCategories: React.FC = () => {
  const d = homeDeviceCategories;

  return (
    <section className="io-home-devices" aria-labelledby="io-home-devices-title">
      <div className="io-home-devices__intro">
        <h2 id="io-home-devices-title" className="io-home-devices__title">
          <span className="io-home-devices__title-plain">{d.titleBefore}</span>
          <span className="io-home-devices__title-accent">{d.titleAccent}</span>
        </h2>
        <p className="io-home-devices__subtitle">{d.subtitle}</p>
      </div>

      <div className="io-home-devices__grid" role="list">
        {d.cards.map((card) => (
          <DeviceCard key={card.id} card={card} photoWellBg={d.photoWellBg} />
        ))}
      </div>
    </section>
  );
};
